import { FC } from "react";
import MailIcon from "@public/svg/envelope.svg";
import { Button } from "@components/atoms/Button";
import styles from "./index.module.scss";

type Props = {
  onConfirmClassroom: () => void;
  email: string;
};

export const GoogleBanner: FC<Props> = ({ onConfirmClassroom, email }) => {
  const isGoogleMail = email.includes("gmail");
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentContainer}>
        <div className={styles.contentWrapper}>
          <div className={styles.titleWrapper}>
            <h4 className={styles.title}>Google Classroom</h4>
          </div>
          <div className={styles.iconWrapper}>
            <MailIcon />
          </div>
        </div>
        <div className={styles.descWrapper}>
          <p className={styles.desc}>
            Sākoties intensīvajam kursam, savā e-pastā saņemsi uzaicinājumu
            pievienoties vietnei Classroom. Lai nepalaistu garām ko svarīgu,
            vēlams ik pa laikam pārbaudīt arī promotions un spam mapes.
          </p>
        </div>
      </div>
      {isGoogleMail && (
        <div className={styles.buttonWrapper}>
          <Button type="link" onClick={onConfirmClassroom}>
            Apstiprini to
          </Button>
        </div>
      )}
    </div>
  );
};
